import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAlertObsoleteSlice = createApi(`GetAlertObsoleteSlice`,"GET");

const GetAlertObsoleteSlice = createSlice({
  name: 'GetAlertObsoleteSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAlertObsoleteSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAlertObsoleteSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAlertObsoleteSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAlertObsoleteSlice.reducer;